<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="m11.453 2.195 6.273 4.077c.222.145.332.217.413.313a.833.833 0 0 1 .157.29c.037.119.037.251.037.515v6.11c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.093c-.535.272-1.235.272-2.635.272H5.666c-1.4 0-2.1 0-2.635-.272a2.5 2.5 0 0 1-1.093-1.093c-.272-.535-.272-1.235-.272-2.635V7.39c0-.264 0-.396.037-.516a.833.833 0 0 1 .157-.29c.08-.095.191-.167.413-.312l6.273-4.077m2.907 0c-.526-.342-.79-.513-1.073-.58a1.667 1.667 0 0 0-.762 0c-.283.067-.546.238-1.072.58m2.907 0 5.16 3.354c.573.372.86.559.959.795a.834.834 0 0 1 0 .646c-.1.236-.386.422-.96.795l-5.16 3.354c-.525.342-.788.513-1.072.58-.25.058-.511.058-.762 0-.283-.067-.546-.238-1.072-.58l-5.16-3.354c-.573-.373-.86-.56-.96-.795a.833.833 0 0 1 0-.646c.1-.236.387-.423.96-.795l5.16-3.354m9.37 13.639-5.536-5m-4.762 0-5.535 5"
    stroke="currentColor"
    stroke-width="1.667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
